import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withKeys as _withKeys, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "roles" }
const _hoisted_2 = { class: "app-wrapper" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "type-data" }
const _hoisted_7 = { class: "type-data" }
const _hoisted_8 = { class: "emq-table-footer" }

import { computed } from 'vue'
import { getRoleList, banRole } from '@/api/common'
import { SEARCH_FORM_RES_PROPS as colProps } from '@/common/constants'
import { dateFormat, throttleBtn } from '@/common/tools'
import CommonPagination from '@/components/commonPagination.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import { ArrowDown, ArrowUp, Refresh, RefreshLeft, Search, Plus } from '@element-plus/icons-vue'
import { pick } from 'lodash'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import UpsertRoleDrawer from './components/UpsertRoleDrawer.vue'
import { checkMenuShow, isSuperadmin } from '@/store/tool'
import { ElMessage } from 'element-plus'
enum Comparator {
  After = 'gte',
  Before = 'lte',
}


import { defineComponent, ref } from 'vue'

const __default__ = defineComponent({
  name: 'Roles',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18nTl('components')

const showDialog = ref(false)
const editRoleFlag = ref(false)
const showRole = ref({})
const showMoreQuery = ref(false)
const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})
const fuzzyParams = ref<Record<string, any>>({
  comparator: Comparator.After,
})
const { enableSelects, evseStateSelects } = useProtocolEnums()
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('evses-detail')
const UpsertRoleDrawerRef = ref()
const addRole = () => {
  editRoleFlag.value = false
  showDialog.value = true
  showRole.value = {}
  UpsertRoleDrawerRef.value?.clearValidate()
}
const editRole = (row: any) => {
  if (!isadmin.value && row.id < 100000) {
    ElMessage.warning(t('Base.needSuperRolePerm'))
    return
  }
  editRoleFlag.value = true
  showRole.value = row
  showDialog.value = true
}

const handleSwitchStatus = async (row: any) => {
  try {
    await banRole({ id: row.id, enable: row.enable })
    if (!row.enable) {
      ElMessage.success(t('Base.disabledSuccess'))
    } else {
      ElMessage.success(t('Base.enableSuccess'))
    }
    handleSearch()
  } catch (error) {
    row.enable = !row.enable
  }
}

const isadmin = computed(() => {
  return isSuperadmin()
})

const handleSearch = async () => {
  params.value = genQueryParams(fuzzyParams.value)
  loadRoles()
}

const handleReset = () => {
  fuzzyParams.value = {
    comparator: Comparator.After,
  }
  handleSearch()
}

const showString = (v: string) => {
  if (v.includes('.')) {
    return t(v)
  }
  return v
}

const genQueryParams = (params: Record<string, any>) => {
  let newParams: Record<string, any> = {}
  const { id, name, enable } = params
  newParams = {
    id: id || undefined,
    name: name || undefined,
    enable: enable || undefined,
  }
  return newParams
}

const loadRoles = async () => {
  lockTable.value = true
  const sendParams = {
    ...params.value,
    pageReq: {
      ...pageParams.value,
    },
  }

  try {
    const { roles = [], pageReply = {} } = await getRoleList(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    tableData.value = roles
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}
const loadRolesRefreshLimit = throttleBtn(loadRoles)

loadRoles()

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      class: "search-wrapper",
      onKeyup: _withKeys(handleSearch, ["enter"])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: fuzzyParams.value.id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fuzzyParams.value.id) = $event)),
                  placeholder: _ctx.$t('Evses.id'),
                  clearable: "",
                  onClear: handleSearch
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: fuzzyParams.value.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fuzzyParams.value.name) = $event)),
                  placeholder: _ctx.$t('Base.name'),
                  clearable: "",
                  onClear: handleSearch
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: fuzzyParams.value.enable,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fuzzyParams.value.enable) = $event)),
                  placeholder: _ctx.$t('Base.isEnabled'),
                  clearable: "",
                  onClear: handleSearch
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(enableSelects), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.label,
                        value: item.value,
                        key: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 16),
            (showMoreQuery.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_el_col, _mergeProps(_unref(colProps), { class: "col-oper" }), {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  plain: "",
                  icon: _unref(Search),
                  onClick: handleSearch
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.search')), 1)
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_component_el_button, {
                  icon: _unref(RefreshLeft),
                  onClick: handleReset
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.reset')), 1)
                  ]),
                  _: 1
                }, 8, ["icon"])
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onKeyup"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          icon: _unref(Plus),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (addRole()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.create')), 1)
          ]),
          _: 1
        }, 8, ["icon"])), [
          [_directive_role, 'rolesAdd']
        ]),
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          icon: _unref(Refresh),
          onClick: _unref(loadRolesRefreshLimit)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
          ]),
          _: 1
        }, 8, ["icon", "onClick"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        ref_key: "TableCom",
        ref: TableCom,
        "row-key": "id"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "name",
            label: _ctx.$t('Base.name')
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_tooltip, {
                placement: "top",
                content: row.id
              }, {
                default: _withCtx(() => [
                  (_unref(checkMenuShow)('rolesUpsert'))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "text",
                        onClick: ($event: any) => (editRole(row))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(showString(row.name)), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(showString(row.name)), 1))
                ]),
                _: 2
              }, 1032, ["content"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "desc",
            label: _ctx.$t('Base.desc')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", null, _toDisplayString(showString(row.desc)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "enable",
            label: _ctx.$t('Base.enable')
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_switch, {
                modelValue: row.enable,
                "onUpdate:modelValue": ($event: any) => ((row.enable) = $event),
                disabled: !_unref(checkMenuShow)('rolesBan'),
                onChange: ($event: any) => (handleSwitchStatus(row))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "updatedAt",
            label: _ctx.$t('Base.updatedAt')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(dateFormat)(Number(row.updatedAt) * 1000)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "createdAt",
            label: _ctx.$t('Base.createdAt')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(dateFormat)(Number(row.createdAt) * 1000)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('Base.operation'),
            "class-name": "table-operation"
          }, {
            default: _withCtx(({ row }) => [
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (editRole(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.edit')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_role, 'rolesUpsert']
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [
          _directive_loading,
          lockTable.value,
          void 0,
          { lock: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(CommonPagination, {
          metaData: _unref(pageMeta),
          "onUpdate:metaData": _cache[4] || (_cache[4] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
          onLoadPage: loadRoles
        }, null, 8, ["metaData"])
      ])
    ]),
    _createVNode(UpsertRoleDrawer, {
      ref_key: "UpsertRoleDrawerRef",
      ref: UpsertRoleDrawerRef,
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showDialog).value = $event)),
      isEdit: editRoleFlag.value,
      role: showRole.value,
      onSubmitted: loadRoles
    }, null, 8, ["modelValue", "isEdit", "role"])
  ]))
}
}

})